// Vendors
import { sessionUtils, cookies } from '@openbank/cf-ui-architecture-core';
import { StorageLocalEnum } from '@openbank/ziniaweb-ui-core-models';
// Constants
import { REDIRECTION_FORCED } from 'constants/app.constants';
import { TOKEN_REFRESH_BEFORE_EXPIRY_MS } from '../constants/token.handlers.constants';
// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const translationsHasBeenLoaded = (informationFlags: AppInformationNeedEnumeration[]): boolean =>
  informationFlags.includes(AppInformationNeedEnumeration.TRANSLATIONS) &&
  !informationFlags.includes(AppInformationNeedEnumeration.AUTHORIZATION_DATA);

const mustBeRedirectedAndNoLogged = (): boolean =>
  Boolean(
    sessionStorage.getItem(REDIRECTION_FORCED) !== null &&
      sessionStorage.getItem(REDIRECTION_FORCED) === getCheckoutIdFromUrl() &&
      !sessionUtils.isUserLogged()
  );

const getMsUntilRefresh = (): number | null => {
  const sessionExpiresAt = cookies.getCookie(StorageLocalEnum.SESSION_EXPIRES_AT);

  if (!sessionExpiresAt) {
    return null;
  }

  const msUntilExpiry = new Date(sessionExpiresAt).getTime() - Date.now();

  if (Number.isNaN(msUntilExpiry)) {
    return null;
  }

  // Renovamos justo antes de que expire, nunca en la primera instancia
  return Math.max(msUntilExpiry - TOKEN_REFRESH_BEFORE_EXPIRY_MS, 0);
};
export { mustBeRedirectedAndNoLogged, translationsHasBeenLoaded, getMsUntilRefresh };
